import DashboardStudent from "components/module/dashboardStudent"

const DashboardStudentPage = () => {
  return <DashboardStudent />
}

export default DashboardStudentPage
